import { ONBOARDINGS } from 'config/environments/shared';

export const getOnboarding = (sectionName: string) => {
  const showOnboarding = () => {
    const initialState = localStorage.getItem(ONBOARDINGS.ALREADY_SAW_ONBOARDING);

    if (!initialState) {
      return true;
    }
    const formattedOnboardingInfos = JSON.parse(initialState);

    if (formattedOnboardingInfos[sectionName]) {
      return false;
    }
    return true;
  };

  const showOnboardingSection = showOnboarding();

  const onboardingViewed = () => {
    const onboardingOptions = localStorage.getItem(ONBOARDINGS.ALREADY_SAW_ONBOARDING);
    const formattedOnboartingOptions = onboardingOptions ? JSON.parse(onboardingOptions) : {};
    const newOnboardingOptions = {
      ...formattedOnboartingOptions,
      [sectionName]: true,
    };
    localStorage.setItem(ONBOARDINGS.ALREADY_SAW_ONBOARDING, JSON.stringify(newOnboardingOptions));
  };

  return {
    showOnboardingSection,
    onboardingViewed,
  };
};
